<template>
    <div v-if="ready" class="estate-detail-menu">
        <div class="container">
            <div class="row max-500" v-if="lang.labels">
                <template v-if="config_estate.appointment">
                    <div class="col-auto">
                        <a :href="'tel:' + this.estate.agency.phone" class="btn btn-network phone" @click="trackPhone()">
                            <masked-image class="icon_action" src="/img/icons/phone.svg" :alt="lang.labels.phone"></masked-image>
                        </a>
                    </div>

                    <div v-if="estate.agency.whatsapp" class="col-auto">
                        <a :href="'https://wa.me/' + this.estate.agency.whatsapp" target="_blank" class="btn btn-network phone" @click="trackPhone()">
                            <img class="icon_action icon-whatsapp" src="/img/icons/whatsapp.svg" :alt="lang.labels.whatsapp">
                        </a>
                    </div>

                    <div class="col-auto">
                        <button class="btn btn-network appointment" @click="openAppointmentModal">
                            <masked-image class="icon_action" src="/img/icons/appointment.svg" :alt="lang.labels.appointment"></masked-image>
                        </button>
                    </div>
                </template>
                <template v-else>
                    <div class="col">
                        <a :href="'tel:' + this.estate.agency.phone" class="btn btn-network light" @click="trackPhone()">
                            <masked-image class="icon_action" src="/img/icons/phone.svg" :alt="lang.labels.phone"></masked-image> {{ lang.labels.phone }}
                        </a>
                    </div>
                </template>

                <div class="col">
                    <button class="btn btn-network" @click="openLeadModal">
                        {{ lang.labels.email }}
                    </button>
                </div>
            </div>
        </div>

        <modal
            name="lead"
            ref="lead"
            extra-class="bottom-modal lead-modal"
        >
            <template slot="body">
                <lead-form :estate="estate" />
            </template>
        </modal>

        <modal
            v-if="lang.titles"
            name="appointment"
            :title="lang.titles.appointment"
            ref="appointment"
            extra-class="full-screen-modal appointment-modal"
        >
            <template slot="body">
                <appointment-form :estate="estate" />
            </template>
        </modal>
    </div>
</template>

<script>
import LeadForm from './LeadForm'
import AppointmentForm from './AppointmentForm'
import Modal from './Modal'

import { isEmpty } from '../helpers/objects'

export default {
    components: {
        'lead-form': LeadForm,
        'appointment-form': AppointmentForm,
        'modal': Modal,
    },

    props: {
        config_estate: {
            type: Object,
            required: false,
        },
        
        estate: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            track_phone: false
        }
    },

    computed: {
        lang() {
            return this.$root.lang.bottom_menu ? this.$root.lang.bottom_menu.estate_detail_menu : []
        },

        ready() {
            return this.lang && ! isEmpty(this.estate) && this.config_estate
        },
    },

    methods: {
        openAppointmentModal() {
            window.events.$emit('showModal', { name: 'appointment' })
        },

        openLeadModal() {
            window.events.$emit('showModal', { name: 'lead' })
        },

        trackPhone() {
            if ((this.track_phone == false) && (this.estate.ad_type == 'estate')) {
                setTimeout(() =>
                    window.trackLibrary.track('actions.telefonoImmobile', {
                        immobile_id: this.estate.id,
                        agenzia_id: this.estate.agency.id,
                        tipoPagina : 'telefono',
                        nazione: this.estate.country,
                        origine: 'portale'
                    })
                , 100)
                this.track_phone = true
            }
        }
    },
}
</script>